module.exports = "<div *ngFor=\"let alert of alerts\" class=\"index\">\r\n  <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\r\n  <div class=\"{{ cssClass(alert) }} alert-dismissable\" [innerHTML]=\"alert.message\">\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/alert/alert.component.html
// module id = ../../../../../src/app/alert/alert.component.html
// module chunks = main